import React, { useEffect, useState } from "react";
import { Button, Calendar, Modal, Checkbox, message, Space, Collapse } from "antd";
import dayjs from "dayjs";
import { CalendarOutlined } from "@ant-design/icons";
import axiosInstance from "../../../utils/axiosInstance";

const { Panel } = Collapse;

const generateTimeSlots = () => {
  const slots = [];
  for (let hour = 10; hour < 18; hour++) {
    slots.push(`${hour.toString().padStart(2, "0")}:00`);
    slots.push(`${hour.toString().padStart(2, "0")}:30`);
  }
  return slots;
};

const timeSlots = generateTimeSlots();

const defaultDisabledDates = []; //"2025-03-10", "2025-03-15"
// const unavailableData = {
//   "2025-03-12": ["10:00", "11:30"],
//   "2025-03-14": ["15:00", "16:30"],
// };

const BookingCalManager = ({ isModalVisible, onCloseCalender, onSetDate }) => {
  const [selectedDates, setSelectedDates] = useState([]);
  const [selectedTimes, setSelectedTimes] = useState({});
  const [selectionType, setSelectionType] = useState({});
  const [unavailableData, setUnavailableData] = useState({});


  useEffect(() => {
    if(isModalVisible){
      getDate();
    }
    setSelectedTimes({})
    setSelectedDates([])
    setSelectionType({})
  }, [isModalVisible])

  const getDate = async () => {
    try {
      const response = await  axiosInstance.get( `/calendar/blocked-slots/`)
      setUnavailableData(response.data.blocked_slots)
    } catch (error) {
      message.error(error.response.data.error);
    }
  }

  const handleDateSelect = (date) => {
    const formattedDate = date.format("YYYY-MM-DD");
    if (dayjs().isAfter(date, 'day') || defaultDisabledDates.includes(formattedDate)) {
      message.warning("This date is disabled");
      return;
    }
    if (selectedDates.includes(formattedDate)) {
      setSelectedDates(selectedDates.filter(d => d !== formattedDate));
      delete selectionType[formattedDate];
      delete selectedTimes[formattedDate];
      setSelectionType({ ...selectionType });
      setSelectedTimes({ ...selectedTimes });
    } else {
      setSelectionType({ ...selectionType, [formattedDate]: null });
      setSelectedTimes({ ...selectedTimes, [formattedDate]: [] });
      setSelectedDates([...selectedDates, formattedDate]);
      message.info("Do you want to select the whole day or specific times?");
    }
  };

  const handleTimeSelect = (date, time) => {
    if (unavailableData[date]?.includes(time)) {
      message.warning("This time is disabled");
      return;
    }
    setSelectedTimes((prev) => {
      const updatedTimes = prev[date]?.includes(time)
        ? prev[date].filter((t) => t !== time)
        : [...(prev[date] || []), time];
      return { ...prev, [date]: updatedTimes };
    });
  };


  const markAsBusy = (type) => {
    let obj = {}
    //const newSlots =
    selectedDates.map((date) =>
      selectionType[date] === "full-date"
        ? obj[date] = timeSlots : selectedTimes[date].length ? obj[date] = selectedTimes[date] : ''  //.map((time) => ({ date, time }))
    );
    onSetDate({ blocked_slots: obj })
  };

  return (
    <div className="w-2/4 mx-auto p-4">
      <Modal
        // title="Set Availability"
        visible={isModalVisible}
        onCancel={onCloseCalender}
        footer={null}
        width={window.innerWidth < 768 ? "90%" : "70%"}
      >
        {/* Top Scrollable Panel */}
        <h3 className="text-lg font-semibold mb-3 text-[#724EFF] border-b-2 border-[#A395DA] pb-2 text-center">
          <CalendarOutlined /> Manage Unavailability
        </h3>
        <div className=" grid grid-cols-3 gap-10 w-full p-4">
          {/* Left Section */}
          <div className="max-h-80  overflow-y-auto p-4 border-b border-gray-300">
            <h3 className="font-semibold">Selected Dates & Times:</h3>
            {selectedDates.length > 0 ? (
              selectedDates.map((date) => (
                <div key={date} className="mt-2">
                  <h3 className="text-lg font-medium">{date}</h3>
                  <p>{selectionType[date] === "full-date" ? "Full Day" : selectedTimes[date]?.join(", ") || "None"}</p>
                </div>
              ))
            ) : (
              <p>None</p>
            )}
          </div>

          {/* Center Section (Calendar) */}
          <Calendar
            onSelect={handleDateSelect}
            disabledDate={(current) => dayjs().isAfter(current, "day")}
            dateFullCellRender={(value) => {
              const formattedDate = value.format("YYYY-MM-DD");
              return (
                <div
                  className={`p-2 rounded ${selectedDates.includes(formattedDate)
                      ? "bg-blue-200"
                      : defaultDisabledDates.includes(formattedDate)
                        ? "bg-red-300"
                        : "bg-white"
                    }`}
                >
                  {value.date()}
                </div>
              );
            }}
          />

          {/* Right Section */}
          <div className="mt-4 max-h-80 overflow-y-auto p-4 border-b border-gray-300">
            <h3 className="font-semibold">Manage Selected Dates & Times:</h3>
            {selectedDates.length > 0 ? (
              selectedDates.map((date) => (
                <div key={date} className="mt-2">
                  <h3 className="text-lg font-medium">{date}</h3>
                  <Space>
                    <Button
                      disabled={unavailableData[date]?.length}
                      onClick={() => setSelectionType({ ...selectionType, [date]: "full-date" })}
                      type={selectionType[date] === "full-date" ? "primary" : "default"}
                    >
                      Whole Day
                    </Button>
                    <Button
                    disabled={unavailableData[date]?.length == timeSlots.length}
                      onClick={() => setSelectionType({ ...selectionType, [date]: "specific-time" })}
                      type={selectionType[date] === "specific-time" ? "primary" : "default"}
                    >
                      Specific Times
                    </Button>
                  </Space>

                  {selectionType[date] === "specific-time" && (
                    <div className="mt-2">
                      {selectionType[date] === "specific-time" && (
                        <Collapse>
                          <Panel header="Select Time Slots" key="1">
                            {timeSlots.map((slot) => (
                              <Checkbox
                                key={slot}
                                checked={selectedTimes[date]?.includes(slot)}
                                onChange={() => handleTimeSelect(date, slot)}
                                className="m-1"
                                disabled={
                                  unavailableData[date]?.includes(slot) ||
                                  dayjs(`${date} ${slot}`, "YYYY-MM-DD HH:mm").isBefore(dayjs())
                                }
                              >
                                {slot}
                              </Checkbox>
                            ))}
                          </Panel>
                        </Collapse>
                      )}



                    </div>
                  )}
                </div>
              ))
            ) : (
              <p>None</p>
            )}
          </div>
        </div>


        <div style={{ marginTop: 16, textAlign: "center" }}>
          <Button
            type="primary"
            onClick={() => { markAsBusy('busy') }}
            style={{ marginRight: 8 }}
          >
            Set as Busy
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default BookingCalManager;